var map = {
	"./aave.png": 1464,
	"./avax.png": 1465,
	"./btc.png": 1466,
	"./btcln.png": 1467,
	"./busd.png": 1468,
	"./comp.png": 1469,
	"./crv.png": 1470,
	"./dai.png": 1471,
	"./eth.png": 370,
	"./gusd.png": 1472,
	"./mkr.png": 1473,
	"./opaig.png": 197,
	"./opaiglg.png": 1474,
	"./pax.png": 1475,
	"./skale.png": 1476,
	"./snx.png": 1477,
	"./uma.png": 1478,
	"./uni.png": 1479,
	"./usdc.png": 1480,
	"./usds.png": 1481,
	"./usdt.png": 1482,
	"./wbtc.png": 1483,
	"./xlm.png": 1484,
	"./yfi.png": 1485,
	"./zusd.png": 1486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1463;